import React from 'react';
import { AUTHOR, PAIN_INTRO, PAINS, PROBLEM_SECTION, SOLUTION_INTRO, STORY_BLOCKS } from '../constants/content';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
export function SalesLetter() {
  return <section className="w-full bg-cream py-12 b760:py-16" data-id="element-202" data-mp="3qsfpg36f4bfh">
      <div className="mx-auto max-w-3xl px-4 b720:px-6" data-id="element-203" data-mp="3ltuog1jcdnpz">
        <Reveal data-id="element-204" data-mp="3lvfgnki6ouko">
          <p className="font-display text-sm font-700 uppercase tracking-[0.16em] text-bordo b640:text-base" data-id="element-205" data-mp="mdpnm7ieepy2">
            {PAIN_INTRO.from}
          </p>
          <p className="mt-2 text-sm italic text-night/70 b640:text-base" data-id="element-206" data-mp="icvyjat7z53l">
            {PAIN_INTRO.re}
          </p>
          <p className="mt-6 text-base font-600 text-night b640:text-lg" data-id="element-207" data-mp="djj94ygpuu9s">
            {PAIN_INTRO.greeting}
          </p>
          <p className="mt-4 font-display text-2xl font-700 text-bordo b640:text-3xl" data-id="element-208" data-mp="161ygykvoh1z5">
            {PAIN_INTRO.question}
          </p>
        </Reveal>

        <Reveal className="mt-6" data-id="element-209" data-mp="119nepbdgt43f">
          <ul className="space-y-3" data-id="element-210" data-mp="119dllex4igti">
            {PAINS.map(pain => <li key={pain} className="rounded-lg border-l-4 border-bordo bg-white px-4 py-3 text-sm leading-relaxed text-night/90 b640:text-base" data-id="element-211" data-mp="2n2gizlonhilg">
                {pain}
              </li>)}
          </ul>
        </Reveal>

        <Reveal className="mt-8 space-y-4" data-id="element-212" data-mp="2i9ndgvlcy68b">
          {STORY_BLOCKS.map(block => <p key={block} className="text-base leading-relaxed text-night/90 b640:text-lg" data-id="element-213" data-mp="24a5j80pam0rk">
              {block}
            </p>)}
        </Reveal>

        {/* Problem */}
        <Reveal className="mt-12" data-id="element-214" data-mp="1vcbrz46dxxb9">
          <h2 className="font-display text-2xl font-700 uppercase leading-tight text-bordo b640:text-4xl" data-id="element-215" data-mp="1zc3zrenyfzfk">
            {PROBLEM_SECTION.title}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-night/90 b640:text-lg" data-id="element-216" data-mp="3pp1olto51kmc">
            {PROBLEM_SECTION.intro}
          </p>
          <ul className="mt-6 space-y-3" data-id="element-217" data-mp="16ho2mkkvm7iw">
            {PROBLEM_SECTION.bullets.map(bullet => <li key={bullet} className="flex gap-3 rounded-lg bg-white px-4 py-3 text-sm leading-relaxed text-night/90 b640:text-base" data-id="element-218" data-mp="11ikyr3gmu7ci">
                <span className="shrink-0 font-700 text-bordo" aria-hidden="true" data-id="element-219" data-mp="xiubvau88bd9">
                  ✕
                </span>
                <span data-id="element-220" data-mp="1p7dxf7on2tat">{bullet}</span>
              </li>)}
          </ul>
          <div className="mt-6 space-y-4" data-id="element-221" data-mp="1l7vak6d9c85c">
            {PROBLEM_SECTION.outro.map(paragraph => <p key={paragraph} className="text-base leading-relaxed text-night/90 b640:text-lg" data-id="element-222" data-mp="1gekbwsilmxoi">
                {paragraph}
              </p>)}
          </div>
        </Reveal>

        {/* Solution */}
        <Reveal className="mt-12" data-id="element-223" data-mp="244wk84hrawfm">
          <h2 className="font-display text-2xl font-700 uppercase leading-tight text-bordo b640:text-4xl" data-id="element-224" data-mp="244o8ifxddx60">
            {SOLUTION_INTRO.title}
          </h2>
          <ul className="mt-6 space-y-3" data-id="element-225" data-mp="2gffeym4s3car">
            {SOLUTION_INTRO.points.map(point => <li key={point} className="flex gap-3 rounded-lg border-l-4 border-mustard bg-white px-4 py-3 text-sm leading-relaxed text-night/90 b640:text-base" data-id="element-226" data-mp="2lf0eaxnv1mo0">
                <span className="shrink-0 font-700 text-mustard-dark" aria-hidden="true" data-id="element-227" data-mp="2ufynrvh2imdz">
                  ✓
                </span>
                <span data-id="element-228" data-mp="345i7t4giomaf">{point}</span>
              </li>)}
          </ul>
        </Reveal>

        {/* Author */}
        <Reveal className="mt-10" data-id="element-229" data-mp="394mffqnsmbyn">
          <div className="rounded-2xl bg-bordo px-5 py-6 text-cream b640:px-7" data-id="element-230" data-mp="393jmzeato1gm">
            <p className="font-display text-2xl font-700 text-mustard" data-id="element-231" data-mp="3d798fuw7a2xf">
              {AUTHOR.name}
            </p>
            <p className="mt-2 text-sm leading-relaxed text-cream/85 b640:text-base" data-id="element-232" data-mp="3i5au8nl0ggcl">
              {AUTHOR.bio}
            </p>
          </div>
        </Reveal>

        <Reveal className="mt-8" data-id="element-233" data-mp="30hie369vlqy0">
          <CtaButton data-id="element-234" data-mp="30ggrc4jhzg0g">{AUTHOR.cta}</CtaButton>
          <p className="mt-2 text-center text-xs text-night/60 b640:text-sm" data-id="element-235" data-mp="3e7u9be1rc5td">
            {AUTHOR.ctaSub}
          </p>
        </Reveal>
      </div>
    </section>;
}